import { Component } from '@angular/core';
import { TranslationService } from '../../common/services/languages/translation.service';
import { Router } from '@angular/router';
import { AuthDispatcher } from '../../store/auth/auth-dispatcher';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../store/state.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.scss'],
    imports: [TranslatePipe]
})
export class ErrorPageComponent {
  /**
   * @arg isLoggedIn value if logged in
   */
  public isLoggedIn;
  constructor(
    public translate: TranslationService,
    public router: Router,
    public authDispatcher: AuthDispatcher,
    public ngRedux: NgRedux<AppState>,
  ) {
    this.isLoggedIn = this.ngRedux.getState().auth.isLoggedIn;
  }
}
